<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-3 px-3 v-if="!currentInternalTransport && !currentShipment">
        <v-layout>
          <v-flex xs12>
            <v-btn flat @click="setMode('INTERN_TRANSPORT')" class="bw-5" :style="buttonStyleInternTransports" :disabled="showInternTransports">Intern transport</v-btn>
            <v-btn flat @click="setMode('INTERN_TRANSPORT_SHIPMENT')" class="bw-8" :style="buttonStyleInternTransportShipments" :disabled="showInternTransportShipments">Intern transport shipments</v-btn>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container fluid py-0 px-3 v-if="!currentInternalTransport && !currentShipment">
        <v-layout style="max-height: calc(100vh - 175px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;" v-if="showInternTransports">
            <v-data-table :headers="headers" :items="internalTransports" hide-actions class="internalTransportTable">
              <template v-slot:items="props">
                <tr @click="selectInternalTransport(props.item)" class="selectable">
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.carrier.name }}</td>
                  <td class="text-xs-left">{{ props.item.from.text }}</td>
                  <td class="text-xs-left">{{ props.item.to.text }}</td>
                  <td class="text-xs-left" style="white-space: nowrap;">{{ props.item.firstPickupDate }}</td>
                  <td class="text-xs-right">{{ props.item.numberOfPallets }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto; margin-top: 10px;" v-if="showInternTransportShipments">
            <v-data-table :headers="shipmentHeaders" :items="shipments" ref="shipments" hide-actions class="shipmentTable" no-data-text="No internal transport shipments found">
              <template v-slot:items="props">
                <tr @click="selectInternalTransportShipment(props.item)" class="selectable">
                  <td class="text-xs-left shipmentNo singleLine">{{ props.item.number }}</td>
                  <td class="text-xs-left nowrap singleLine">{{ stateLabel(props.item.state) }}</td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.suppliers"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.fields"></div></td>
                  <td class="text-xs-left nowrap" style="padding-bottom: 1px !important;"><div v-html="props.item.categories"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.amounts"></div></td>
                  <td class="text-xs-left nowrap"><div v-html="props.item.internalTransportUnloadedDate"></div></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;" v-if="currentInternalTransport">
        <v-layout>
          <v-flex text-xs-right xs12>
            <v-btn flat @click="print" class="bw-3">Print</v-btn>
            <v-btn flat @click="close" class="bw-3">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;" v-if="currentShipment">
        <v-layout>
          <v-flex text-xs-right xs12>
            <v-btn flat @click="confirmDeleteDialog = true" class="bw-3">Delete</v-btn>
            <v-btn flat @click="close" class="bw-3">Close</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentInternalTransport" >
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Internal transport">
                <v-flex xs12 sm3>
                  <v-label>Carrier</v-label>
                </v-flex>
                <v-flex xs12 sm9 class="headerValue">
                  {{ currentInternalTransport.carrier.name }}
                </v-flex>
                <v-flex xs12 sm3>
                  <v-label>Pickup address</v-label>
                </v-flex>
                <v-flex xs12 sm9 class="headerValue">
                  {{ currentInternalTransport.from.text }}
                </v-flex>
                <v-flex xs12 sm3>
                  <v-label>Delivery address</v-label>
                </v-flex>
                <v-flex xs12 sm9 class="headerValue">
                  {{ currentInternalTransport.to.text }}
                </v-flex>
                <v-flex xs12 sm3>
                  <v-label>Deadline</v-label>
                </v-flex>
                <v-flex xs12 sm9 class="headerValue">
                  {{ currentInternalTransport.firstPickupDate }}
                </v-flex>
              </PanelColumn>
            </Panel>
            <v-container fluid py-2 px-3>
              <v-layout>
                <v-flex text-xs-right style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
                  <v-data-table :headers="palletHeaders" :items="pallets" hide-actions class="internalTransportPalletTable">
                    <template v-slot:items="props">
                      <tr>
                        <td class="text-xs-left" style="white-space: nowrap; width: 120px;">{{ props.item.number }}</td>
                        <td class="text-xs-left" style="white-space: nowrap; width: 120px;">{{ props.item.externalNumber }}</td>
                        <td class="text-xs-left" style="white-space: nowrap; width: 140px;">{{ props.item.plannedShipmentNumber }}</td>
                        <td class="text-xs-left" style="white-space: nowrap; width: 140px;">{{ props.item.pickupDate }}</td>
                        <td class="text-xs-left" style="white-space: nowrap; width: 140px;">{{ props.item.stateLabel }}</td>
                        <td class="text-xs-left" style="white-space: nowrap;">
                          <div v-for="(palletItem, i) in props.item.items" :key="i">
                            {{ (palletItem.category ? palletItem.category.label : palletItem.categoryName) + ', ' + (palletItem.amount ? palletItem.amount : palletItem.plannedAmount) + 'pcs.' }}
                          </div>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-0 px-0 v-if="currentShipment">
        <v-layout style="max-height: calc(100vh - 160px);">
          <v-flex style="overflow-y: auto;">
            <Panel>
              <PanelColumn title="Shipment">
                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>Shipment no.</v-label>
                </v-flex>
                <v-flex xs12 sm3 lg3 style="height: 35px;">
                  {{ currentShipment.number }}
                </v-flex>
                <v-flex xs0 sm1 lg4 style="height: 10px;">&nbsp;</v-flex>
                <v-flex xs12 sm5 lg3 style="height: 35px; padding-top: 3px;" px-5 text-xs-right>
                  <div v-if="currentShipment.createdByName !== ''">
                    <span>Created by {{ currentShipment.createdByName }}</span>
                  </div>
                </v-flex>

                <v-flex xs12 sm3 lg2 style="height: 35px;">
                  <v-label>License plate(s)</v-label>
                </v-flex>
                <v-flex xs12 sm9 lg6 style="height: 35px;">
                  {{ currentShipment.licensePlate }}
                </v-flex>

                <v-flex xs12 style="padding-top: 20px;" v-if="hasPallets">
                  <v-label>Pallets</v-label>
                </v-flex>
                <v-flex xs12 v-if="hasPallets">
                  <table class="palletPosition" width="100%">
                    <tr>
                      <ShipmentPallet number="1" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="3" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="5" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="7" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="9" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                    </tr>
                    <tr>
                      <ShipmentPallet number="2" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="4" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="6" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="8" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                      <ShipmentPallet number="10" :palletPositions="palletPositions" :half="false" :pallet-selected="currentPallet" :pallet-position-selected="currentPalletPosition"/>
                    </tr>
                  </table>
                </v-flex>
              </PanelColumn>
            </Panel>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>
    <v-dialog v-model="confirmDeleteDialog" persistent width="500" v-if="currentShipment">
      <v-card pa-5>
        <v-card-title class="headline">Delete internal transport shipment</v-card-title>
        <v-card-text>Are you sure you want to delete this internal transport shipment?</v-card-text>
        <v-card-text v-if="currentShipment.state !== 'PLANNED'" style="padding-top: 0;">Please note that delivery has already started and you might loose data about this shipment.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="deleteShipment">Yes</v-btn>
          <v-btn flat @click="confirmDeleteDialog = false">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ErrorDialog ref="errorDialog"/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import Panel from '../components/Panel'
import ErrorDialog from '../components/ErrorDialog'
import PanelColumn from '../components/PanelColumn'
import ShipmentPallet from '../components/ShipmentPallet'
import axios from 'axios'

export default {
  name: 'Transports',
  components: { Header, Sidebar, Footer, Panel, PanelColumn, ShipmentPallet, ErrorDialog },
  data () {
    return {
      mode: 'INTERN_TRANSPORT',
      internalTransports: [],
      shipments: [],
      currentInternalTransport: null,
      currentShipment: null,
      currentPallet: null,
      currentPalletPosition: null,
      confirmDeleteDialog: false,
      pallets: [],
      headers: [
        { text: 'Carrier', value: 'carrier.name', sortable: false },
        { text: 'Pickup address', value: 'from.text', sortable: false },
        { text: 'Delivery address', value: 'to.text', sortable: false },
        { text: 'Deadline', value: 'firstPickupDate', sortable: false },
        { text: 'Amount', value: 'numberOfPallets', sortable: false }
      ],
      palletHeaders: [
        { text: 'Pallet no.', value: 'number', sortable: false },
        { text: 'Ext. pallet no.', value: 'externalNumber', sortable: false },
        { text: 'Shipment no.', value: 'plannedShipmentNumber', sortable: false },
        { text: 'Loading date', value: 'pickupDate', sortable: false },
        { text: 'State', sortable: false },
        { text: 'Category', sortable: false }
      ],
      shipmentHeaders: [
        { text: 'No.', value: 'number', sortable: true },
        { text: 'State', value: 'state', sortable: true },
        { text: 'Supplier', value: 'suppliers', sortable: false },
        { text: 'Field', value: 'fields', sortable: false },
        { text: 'Category', value: 'categories', sortable: false },
        { text: 'Amount', value: 'amounts', sortable: false },
        { text: 'Delivery date', value: 'internalTransportUnloadedDate', sortable: true }
      ],
      palletPositions: [
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
        {}, {}, {}, {}, {}, {}, {}, {}, {}, {}
      ]
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', { key: 'transports' })
    this.loadInternalTransport()
    this.loadShipments()
  },
  computed: {
    showInternTransports: function () {
      return this.mode === 'INTERN_TRANSPORT'
    },
    showInternTransportShipments: function () {
      return this.mode === 'INTERN_TRANSPORT_SHIPMENT'
    },
    buttonStyleInternTransports () {
      return (this.showInternTransports ? ' color: #606060 !important;' : '')
    },
    buttonStyleInternTransportShipments () {
      return (this.showInternTransportShipments ? ' color: #606060 !important;' : '')
    },
    hasPallets () {
      return this.pallets && this.pallets.length > 0
    }
  },
  methods: {
    setMode (mode) {
      this.mode = mode
    },
    stateLabel: function (state) {
      switch (state) {
        case 'DRAFT': return 'Draft'
        case 'PLANNED': return 'Planned'
        case 'IN_PRODUCTION': return 'In production'
        case 'PRODUCED': return 'Produced'
        case 'READY_FOR_PICKUP': return 'Ready for pickup'
        case 'DELIVERED': return 'Delivered'
      }
      return 'Unknown'
    },
    loadInternalTransport () {
      axios.get('/backend/rest/internal_transport')
        .then(response => {
          this.internalTransports = response.data
        })
    },
    selectInternalTransport (internalTransport) {
      this.currentInternalTransport = internalTransport
      axios.get('/backend/rest/internal_transport/carrier/' + internalTransport.carrier.id + '/from/' + internalTransport.from.id + '/to/' + internalTransport.to.id)
        .then(response => {
          this.pallets = response.data
        })
    },
    loadShipments () {
      let url = '/backend/rest/shipment/summary?internalTransport=true'
      axios.get(url)
        .then(response => {
          this.shipments = response.data
        })
    },
    selectInternalTransportShipment (item) {
      this.currentPallet = null
      this.resetPalletPositions()
      this.loadShipment(item.id, function (t) {
        t.loadPalletsForShipment()
      })
    },
    resetPalletPositions () {
      for (let i in this.palletPositions) {
        this.$set(this.palletPositions, i, {})
      }
    },
    loadShipment (shipmentId, success) {
      axios.get('/backend/rest/shipment/' + shipmentId)
        .then(response => {
          // console.log('Got shipment: ' + JSON.stringify(response.data))
          this.currentShipment = response.data
          if (success) {
            success(this)
          }
        })
    },
    loadPalletsForShipment () {
      this.pallets = []
      if (this.currentShipment) {
        // console.log('Loading pallets for shipment ' + this.currentShipment.id)
        for (let i = 0; i < 20; i++) {
          this.$set(this.palletPositions, i, {})
        }
        axios.get('/backend/rest/pallet/shipment/' + this.currentShipment.id)
          .then(response => {
            // console.log('Pallets: ' + JSON.stringify(response.data))
            let pallets = response.data
            if (pallets.length === 0) {
              pallets = [ {} ]
            }
            for (let pallet of pallets) {
              // console.log('Set pallet on position ' + (pallet.position - 1) + ': ' + JSON.stringify(pallet))
              this.$set(this.palletPositions, pallet.position - 1, pallet)
            }
            this.pallets = pallets
          })
      }
    },
    deleteShipment () {
      axios.delete('/backend/rest/shipment/' + this.currentShipment.id)
        .then(response => {
          this.loadShipments()
        })
        .catch(error => {
          console.log(error.response.data.message)
        })

      this.confirmDeleteDialog = false
      this.currentShipment = null
    },
    print () {
      let url = '/backend/print/internalTransport.xhtml?carrierId=' + this.currentInternalTransport.carrier.id + '&locationId=' + this.currentInternalTransport.from.id + '&pickupAddressId=' + this.currentInternalTransport.to.id + '&title=Internal transport'
      window.open(url)
    },
    close () {
      this.currentInternalTransport = null
      this.currentShipment = null
      this.pallets = []
    }
  }
}
</script>
<style scoped>
  html {
    overflow-y: auto;
  }
  .headerValue {
    line-height: 26px;
  }
  .palletPosition {
    border-collapse: collapse;
    margin-left: auto;
    margin-right: auto;
  }
  .palletPosition tr td {
    font-size: 11px;
    width: 20%;
    border: 1px solid rgba(0, 77, 64, 0.6);
    padding: 6px;
    vertical-align: middle;
    text-align: center;
    height: 30px;
  }
  .palletPosition tr td.selected {
    color: white;
    background-color: rgba(0, 77, 64, 0.8);
  }
  table.v-table tbody tr td.singleLine {
    padding-top: 1px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Transports.vue